/*
 * <app-price-button> — "cheaper in the app" button above Add to Cart
 * (snippets/app-price-button.liquid). Points the link at the store for the
 * shopper's device. Android: an intent:// URL for our app package built from the
 * NAPPS dynamic link (opens the app if installed, else Google Play). iOS: the
 * same dynamic link as a universal link (opens the app if installed, else ends
 * on the App Store via the npp_app_fallback hop in layout/theme.liquid).
 * Rendered with
 * `hidden` and only revealed on iOS/Android, so desktop never shows it.
 * Re-created by product-info.js on every variant switch, so all work happens
 * in connectedCallback.
 */
if (!customElements.get('app-price-button')) {
  customElements.define(
    'app-price-button',
    class AppPriceButton extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('.app-price-button__link');
        if (!link) return;

        const ua = navigator.userAgent || '';
        // iPadOS reports itself as Mac; touch points tell them apart.
        const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
        const isAndroid = /Android/i.test(ua);
        const { deepLink, iosUrl, androidUrl, androidPackage } = this.dataset;

        if (!isIOS && !isAndroid) return; // desktop: stay hidden

        if (isAndroid) {
          // Intent URL: opens the installed app (package) with the deep link, else Google Play.
          const intent = AppPriceButton.androidIntent(deepLink, androidPackage, androidUrl);
          if (intent) {
            link.href = intent;
            link.removeAttribute('target');
          } else if (androidUrl) link.href = androidUrl;
        } else if (deepLink) {
          // Universal link: iOS opens the installed app. Without the app, NAPPS redirects to our
          // store keeping the query, and layout/theme.liquid forwards `npp_app_fallback=ios` to the
          // App Store. Same tab: a universal link opened in a new tab can stay in the browser.
          link.href = deepLink + (deepLink.includes('?') ? '&' : '?') + 'npp_app_fallback=ios';
          link.removeAttribute('target');
        } else if (iosUrl) link.href = iosUrl;
        this.hidden = false;
      }

      static androidIntent(deepLink, pkg, fallbackUrl) {
        if (!deepLink || !pkg) return null;
        try {
          const u = new URL(deepLink);
          const fallback = fallbackUrl ? `S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};` : '';
          return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=${u.protocol.replace(':', '')};package=${pkg};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;${fallback}end`;
        } catch (e) {
          return null;
        }
      }
    }
  );
}
